import React from "react";
import { useYmDocumentReportQuery } from "services/ymQueryHooks";
import Box from "@mui/material/Box";
import Text from "@smartinspection/ameta-frontend-components/display/Text";
import HorizontalSplit from "@smartinspection/ameta-frontend-components/layout/HorizontalSplit";
import Divider from "@mui/material/Divider";
import Button from "@smartinspection/ameta-frontend-components/controls/Button";
import CircularProgress from "@smartinspection/ameta-frontend-components/display/CircularProgress";
import IconButton from "@smartinspection/ameta-frontend-components/controls/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import RotateRightIcon from "@mui/icons-material/RotateRight";
function UploadDocumentReport({
  documentIdList,
  dialogBoxTitle,
  close,
}: {
  documentIdList: string[];
  dialogBoxTitle: (title: string) => void;
  close: () => void;
}) {
  const documentReport = useYmDocumentReportQuery(documentIdList).data;
  let noDivider: number = -1;
  return (
    <Box sx={{ height: "100%" }}>
      {Object.keys(documentReport).length > 0 ? (
        Object.values(documentReport).map((report, index) => {
          dialogBoxTitle("Resultater");
          const dateTime = new Date(report.createdAt * 1000);
          noDivider = noDivider + 1;
          return (
            <Box sx={{ p: 1 }} key={index}>
              {noDivider > 0 && <Divider />}
              <HorizontalSplit
                top={
                  <Box>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Text variant="body1" sx={{ fontWeight: "bold" }}>
                        Documentnavn:
                      </Text>
                      <IconButton type="info" onClick={() => {}}>
                        {report.status === "completed with errors" ? (
                          <WarningIcon sx={{ color: "#f0ad4e" }} />
                        ) : report.status === "completed" ? (
                          <CheckCircleIcon sx={{ color: "#5cb85c" }} />
                        ) : report.status === "processing" ? (
                          <RotateRightIcon sx={{ color: "#0275d8" }} />
                        ) : report.status === "initial" ? (
                          <PlayArrowIcon sx={{ color: "#0275d8" }} />
                        ) : (
                          <ErrorIcon sx={{ color: "#d9534f" }} />
                        )}
                      </IconButton>
                    </Box>
                    <Text variant="body1">{report.documentName}</Text>
                    <Text variant="body1" sx={{ fontWeight: "bold" }}>
                      Opprettet:
                    </Text>
                    <Text variant="body1">
                      {dateTime.toLocaleString("no-NO")}
                    </Text>
                  </Box>
                }
                bottom={
                  <Box>
                    <Text variant="body1" sx={{ fontWeight: "bold" }}>
                      Status:
                    </Text>
                    <Text variant="body1">
                      {report.status === "completed with errors"
                        ? "Fullført med feil"
                        : report.status === "completed"
                        ? "Fullført"
                        : report.status === "processing"
                        ? "Prosesserer"
                        : report.status === "initial"
                        ? "Stater for prosesserer"
                        : "Mislyktes"}
                    </Text>
                    {report?.parsingReport?.numberOfMeasurementsAdded && (
                      <Text variant="body1" sx={{ fontWeight: "bold" }}>
                        Resultat:
                      </Text>
                    )}
                    <Box>
                      {report?.parsingReport?.numberOfMeasurementsAdded &&
                        report.parsingReport?.numberOfMeasurementsAdded +
                          " målinger ble lagt til."}
                    </Box>
                    {report?.parsingReport?.errors && (
                      <Text variant="body1" sx={{ fontWeight: "bold" }}>
                        Feilmeldinger:
                      </Text>
                    )}
                    {report?.parsingReport?.errors?.unknownfieldName &&
                      "Det er ukjente kolonnenavn i filen. Du kan fikse filen og laste opp på nytt."}
                    {report?.parsingReport?.errors?.unknownfileExtension &&
                      "Filtypen støttes ikke av systemet."}
                    {report?.parsingReport?.errors
                      ?.missingStationsWithYmPoints &&
                      report?.parsingReport?.errors?.missingStationsWithYmPoints.length.toString() +
                        " målinger kan ikke plasseres. Dette kan være fordi ym-punktene mangler med stasjoner. Disse ukjente stasjon/er ble oppdaget: " +
                        report?.parsingReport?.errors?.missingStationsWithYmPoints.toString() +
                        ". Du kan prøve å legge til disse stasjon/er med ym-punktene og laste opp filen på nytt. "}
                    {report?.parsingReport?.errors?.unknownStations &&
                      report?.parsingReport?.errors?.unknownStations.length.toString() +
                        " målestasjoner f.eks " +
                        report?.parsingReport?.errors?.unknownStations.toString() +
                        "er ukjente i filen. Ta kontakt med administrasjonen for å legge dem til. "}
                    {report?.parsingReport?.errors
                      ?.unkownMeasurementTypesAdded &&
                      report?.parsingReport?.errors?.unkownMeasurementTypesAdded.length.toString() +
                        "ukjent måletyper finnes i filen. Disse ukjente måletyper er: " +
                        report?.parsingReport?.errors?.unkownMeasurementTypesAdded.toString() +
                        ". Du kan fiks filen og laste opp på nytt. "}
                  </Box>
                }
              />
            </Box>
          );
        })
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {dialogBoxTitle("Legg til ny rapport")}
          <Box>
            <CircularProgress size={150} />
            <Text variant="h5" sx={{ fontWeight: "bold" }}>
              Prosesserer...
            </Text>
          </Box>
        </Box>
      )}
      {Object.keys(documentReport).length > 0 && (
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button type="error" endIcon={<CancelIcon />} onClick={close}>
            Lukk
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default UploadDocumentReport;
